import * as h2Api from '../h2Api'
import * as parentPortalActions from '../actions/parentPortal'

const initialState = {
  requestInfo: {},
  associationKey: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case parentPortalActions.LOAD_REQUEST_INFO:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          requestInfo: action.restCall.result
        }
      }

      return state

    case parentPortalActions.ASSOCIATION_KEY:
      return {
        ...state,
        associationKey: action.key
      }

    case parentPortalActions.CLEAR_ASSOCIATION_KEY:
      return {
        ...state,
        associationKey: null
      }

    default:
      return state
  }
}
